import './DashboardStatCard.scss'

export default function DashboardStatCard({
  title,
  value,
  growth,
  negative,
  subtitle,
}) {
  return (
    <div className="dashboard-stat-card">
      <div className="dashboard-stat-card__title">
        {title}
      </div>

      <div className="dashboard-stat-card__value">
        {value}
      </div>

      {growth && (
        <div
          className={`dashboard-stat-card__growth ${
            negative ? 'negative' : 'positive'
          }`}
        >
          {growth}
        </div>
      )}

      {subtitle && (
        <div className="dashboard-stat-card__subtitle">
          {subtitle}
        </div>
      )}
    </div>
  )
}